module.exports = __webpack_public_path__ + "static/media/Szandra-profil3.c1893174.JPG";